import EventTypes from "../../../shared/EventTypes";
import AbstractAction from "../AbstractAction";

export default class MoveLabelAction extends AbstractAction {
    constructor(provider, labelCollection, rows) {
        super(provider);

        this.labelCollection = labelCollection;
        this.rows = rows;
    }

    finish(oldIndex, newIndex) {
        if (oldIndex === newIndex) {
            this.actions.discard();
            return;
        };

        this.oldIndex = oldIndex;
        this.newIndex = newIndex;

        let field = this.rows.splice(oldIndex, 1)[0];
        this.rows.splice(newIndex, 0, field);
        this.labelCollection.move(oldIndex, newIndex);
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.labelCollection.parent);

        super.finish();
    }

    undo() {
        this.labelCollection.move(this.newIndex, this.oldIndex);
        this.getTab('info').reload(this.labelCollection.parent);
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.labelCollection.parent);
    }

    redo() {
        this.labelCollection.move(this.oldIndex, this.newIndex);
        this.getTab('info').reload(this.labelCollection.parent);
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.labelCollection.parent);
    }
}
